let etfs = {
  line1: [
    "SQQQ",
    "SPY",
    "XLF",
    "QQQ",
    "EEM",
    "TQQQ",
    "EWZ",
    "XLE",
    "IWM",
    "SLV",
    "VXX",
    "GDX",
    "EFA",
    "HYG",
    "SOXL",
    "FXI",
    "SDS",
    "EZU",
    "UPRO",
    "PDBC",
    "ERX",
    "VOO",
    "DIA",
    "TBT",
    "INDA",
  ],
  line2: [
    "SJNK",
    "FNGU",
    "XLRE",
    "SRTY",
    "EWH",
    "VGK",
    "IVV",
    "VNQ",
    "RSX",
    "SMH",
    "JETS",
    "FNGD",
    "XLC",
    "EZU",
    "UPRO",
    "PDBC",
    "ERX",
    "VOO",
    "DIA",
    "TBT",
    "INDA",
    "VTI",
    "XLY",
    "DRIP",
  ],
  line3: [
    "TLT",
    "LQD",
    "XLI",
    "IAU",
    "XLP",
    "XLU",
    "ARKK",
    "GLD",
    "XLV",
    "KRE",
    "IEMG",
    "IYR",
    "SOXS",
    "VWO",
    "TZA",
    "VEA",
    "JNK",
  ],
};

module.exports = etfs;
